import { useEffect, useRef } from "react";
import * as journifyTrackingUserEvents from "../services/trackingUserEvents";

const SESSION_KEY = "journify_view_login_screen_fired";

export default function useTrackViewLoginScreenOnce({
  isOpen = true,
  active = true,
  payload = {},
} = {}) {
  const localFiredRef = useRef(false);

  useEffect(() => {
    if (!isOpen || !active) return;

    // منع التكرار داخل نفس الرندر/StrictMode
    if (localFiredRef.current) return;

    // منع التكرار طوال الجلسة
    const alreadyFired = sessionStorage.getItem(SESSION_KEY);
    if (alreadyFired) return;

    localFiredRef.current = true;
    sessionStorage.setItem(SESSION_KEY, "1");

    // journifyTrackingUserEvents.trackViewLoginScreen(payload);
  }, [isOpen, active, payload]);
}
